(() => {
  angular
    .module('complianceFrameworkApp.core')
    .factory('sessionService', sessionService);

  /* ngInject */
  function sessionService($window) {
    let _user = angular.fromJson($window.localStorage.user);
    let _authToken = angular.fromJson($window.localStorage.authToken);
    let _productRoles = angular.fromJson($window.localStorage.productRoles);
    let _impersonatedUser = angular.fromJson($window.localStorage.impersonatedUser);

    return {
      getAuthToken: () => {
        return _authToken;
      },

      setAuthToken: authToken => {
        _authToken = authToken;
        $window.localStorage.authToken = angular.toJson(authToken);
      },

      getImpersonatedUser: () => {
        return _impersonatedUser;
      },

      setImpersonatedUser: impersonatedUser => {
        _impersonatedUser = impersonatedUser;
        $window.localStorage.impersonatedUser = angular.toJson(impersonatedUser);
      },

      getUser: () => {
        return _user;
      },

      setUser: user => {
        _user = user;
        $window.localStorage.user = angular.toJson(user);
      },

      getProductRoles: () => {
        return _productRoles;
      },

      setProductRoles: productRoles => {
        _productRoles = productRoles;
        $window.localStorage.productRoles = angular.toJson(productRoles);
      },

      hasProductRole: (product, role) => {
        for (var i = 0; i < _productRoles.length; i++) {
          var productRole = _productRoles[i];
          if (productRole.product_name === product && productRole.role_name === role) {
            return true;
          }
        }

        return false;
      },

      destroySession: () => {
        _authToken = null;
        _impersonatedUser = null;
        _productRoles = null;
        _user = null;

        $window.localStorage.removeItem('authToken');
        $window.localStorage.removeItem('impersonatedUser');
        $window.localStorage.removeItem('productRoles');
        $window.localStorage.removeItem('user');
      }
    };
  }
})();
